module.exports = __webpack_public_path__ + "static/media/12.981f2423.jpg";